<template>
	<section>
		<v-form ref="formActual">
			<v-simple-table>
				<thead>
					<tr>
						<th colspan="2" class="font-weight-medium">
							Fecha de Consulta
						</th>
						<th>
							<date-picker
								v-model="valor.FechaConsulta"
								:rules="[
									() =>
										!!valor.FechaConsulta ||
										'Campo requerido'
								]"
							></date-picker>
						</th>
					</tr>
					<tr>
						<th colspan="2" class="font-weight-medium">
							Fecha de Resultados
						</th>
						<th>
							<date-picker
								v-model="valor.FechaResultados"
								:rules="[
									() =>
										!!valor.FechaResultados ||
										'Campo requerido'
								]"
							></date-picker>
						</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="c in categorias">
						<tr :key="c.ID">
							<td colspan="4" class="text-h5 primary--text">
								{{ c.Etiqueta }}
							</td>
						</tr>
						<tr
							:key="'d_' + i + c.Propiedad"
							v-for="(data, i) in valor[c.Propiedad]"
						>
							<td>{{ data.Nombre }}</td>
							<td>{{ data.Referencia }}</td>
							<td style="display: flex;">
								<v-text-field
									type="number"
									hide-details="auto"
									class="campo-formulario"
									v-model="data.Valor"
								></v-text-field>
								<template
									v-if="
										(data.LimiteInferior ||
											data.LimiteSuperior) &&
											!!data.Valor
									"
								>
									<template v-if="mostrarAdvertencia(data)">
										<v-icon color="red">close</v-icon>
									</template>
									<template v-else>
										<v-icon color="green">checkmark</v-icon>
									</template>
								</template>
							</td>
						</tr>
					</template>
				</tbody>
			</v-simple-table>
		</v-form>
		<v-footer app class="pt-3 d-print-none">
			<v-btn color="secondary" x-large @click.prevent="regresar"
				>Regresar <v-icon>chevron_left</v-icon></v-btn
			>
			<v-spacer></v-spacer>
			<v-btn color="primary" x-large @click.prevent="guardar"
				><v-icon>save</v-icon> Guardar
			</v-btn>
		</v-footer>
	</section>
</template>

<script>
import ServicioVisita from "../../../services/visita";

import ServicioCatalogos from "../../../services/catalogos";
import DatePicker from "../../../components/DatePicker.vue";
export default {
	components: { DatePicker },
	name: "bioquimicos",
	async mounted() {
		this.obtenerInfoPaso();
	},
	data() {
		return {
			valor: { ...ServicioCatalogos.catalogos.ResultadosBioquimicos },
			categorias: [
				{
					ID: 1,
					Etiqueta: "Función Renal",
					Propiedad: "FuncionRenal"
				},
				{
					ID: 2,
					Etiqueta: "Química Sanguínea",
					Propiedad: "QuimicaSanguinea"
				},
				{
					ID: 3,
					Etiqueta: "Biometría Hemática",
					Propiedad: "BiometriaHematica"
				},
				{
					Etiqueta: "Examen General de Orina",
					Propiedad: "ExamenGeneralOrina"
				}
			]
		};
	},
	methods: {
		async obtenerInfoPaso() {
			const res = await ServicioVisita.obtenerInfoPaso(
				"Bioquimicos",
				this.visitaId
			);
			if (res.data.result === 1 && res.data.data.Table0.length) {
				const valor = JSON.parse(res.data.data.Table0[0].Bioquimicos);
				if (valor) this.valor = valor;
			}
		},
		regresar() {
			this.$router.back();
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioVisita.guardarBioquimicos(
					this.visitaId,
					this.valor
				);

				if (res.data.result === 1) {
					this.$router.back();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		},
		mostrarAdvertencia(data) {
			if (data.LimiteInferior && data.Valor < data.LimiteInferior) {
				return true;
			}
			if (data.LimiteSuperior && data.Valor > data.LimiteSuperior) {
				return true;
			}
			return false;
		}
	},
	computed: {
		visitaId() {
			return this.$route.params.visitaId;
		}
	}
};
</script>
